import { apiClient } from '../client';
import { mapLeaderboardResponseWireToDomain } from '../mappers/leaderboard';
import { leaderboardResponseWireSchema, type LeaderboardResponseWire } from '../schemas/leaderboard';
import type { LeaderboardCategory, LeaderboardResponse } from '@/types/leaderboard';

export async function getLeaderboard(
  category: LeaderboardCategory,
): Promise<LeaderboardResponse> {
  const wireData = await apiClient.get<LeaderboardResponseWire>(
    `/api/leaderboard?category=${category}`,
  );
  const validated = leaderboardResponseWireSchema.parse(wireData);
  return mapLeaderboardResponseWireToDomain(validated);
}
